// extracted by mini-css-extract-plugin
export default {"link":"GuestContentHeader_link--XA_","headerTitleWrapper":"GuestContentHeader_headerTitleWrapper--RIo","title":"GuestContentHeader_title--eVf"};